// utils/rem.js
function setRem() {
  const baseSize = 16;
  const scale = document.documentElement.clientWidth / 1080;
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
}

window.onresize = setRem;
setRem();
